// removed by extract-text-webpack-plugin
module.exports = {"buttonsContainer":"_2bjU177z3XC84cg177Q5k"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/fullScreenConfirmationPopup.css
// module id = 866
// module chunks = 0